import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

export function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      void navigate(session ? '/' : '/login');
    };
    void checkSession();
  }, [navigate]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-surface text-ink">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 border-2 border-accent border-t-transparent rounded-full animate-spin" />
        <p className="text-sm text-muted">Autenticando...</p>
      </div>
    </main>
  );
}
